import React, { CSSProperties, ReactNode } from 'react';
import AntdDivider from 'antd/lib/divider';

/**
 * {@docCategory HorizontalDivider}
 */
export interface HorizontalDividerProps {
   titlePosition?: 'left' | 'center' | 'right';

   /**
    * Sets a className on the component.
    */
   className?: string;

   /**
    * Sets styles on the component.
    */
   style?: CSSProperties;

   /**
    * The title.
    */
   children?: ReactNode;
}

export const HorizontalDivider = (props: HorizontalDividerProps) => {
   return (
      <AntdDivider
         type={'horizontal'}
         orientation={props.titlePosition || 'left'}
         className={`uf-divider-horizontal ${props.className || ''}`}
         style={props.style}
      >
         {props.children}
      </AntdDivider>
   );
};
